"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsive = void 0;
var screen_1 = require("./screen");
exports.responsive = {
    xsMax: "@media (max-width: " + screen_1.screen.xsMax + "px)",
    xsPlus: "@media (min-width: " + screen_1.screen.xsMin + "px)",
    smMax: "@media (max-width: " + screen_1.screen.smMax + "px)",
    smPlus: "@media (min-width: " + screen_1.screen.smMin + "px)",
    mdMax: "@media (max-width: " + screen_1.screen.mdMax + "px)",
    mdPlus: "@media (min-width: " + screen_1.screen.mdMin + "px)",
    lgMax: "@media (max-width: " + screen_1.screen.lgMax + "px)",
    lgPlus: "@media (min-width: " + screen_1.screen.lgMin + "px)",
};
//# sourceMappingURL=responsive.js.map